import { render, staticRenderFns } from "./topController.vue?vue&type=template&id=faee4d38&scoped=true"
import script from "./topController.vue?vue&type=script&lang=js"
export * from "./topController.vue?vue&type=script&lang=js"
import style0 from "./topController.vue?vue&type=style&index=0&id=faee4d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faee4d38",
  null
  
)

export default component.exports